import { mapGetters, mapActions } from 'vuex'
import InsuranceModule, { MODULE_NAME } from './index'

const InsuranceMixin = {
  namespaced: InsuranceModule.namespaced,
  computed: { ...mapGetters(MODULE_NAME, Object.keys(InsuranceModule.getters)) },
  methods: { ...mapActions(MODULE_NAME, Object.keys(InsuranceModule.actions)) }
}

export default InsuranceMixin



// WEBPACK FOOTER //
// ./src/store/module/insurance/mixin.js